import React, { Component } from "react"
import Spin from "@infotech/uikit-spin"
import { withRouter } from "react-router-dom"
import { LoaderIcon } from "@infotech/uikit-icons"
import { compose } from "recompact"
import { connect } from "react-redux"
import omit from "lodash/omit"
import withQueryParams from "src/hocs/withQueryParams"
import { refreshTokenByCode } from "src/engine/modules/token"
import { setTokens } from "src/engine/modules/session/actions/creators"
import { selectToken } from "../selectors"
import { redirectToLoginPage } from "../helpers"
import styles from "./styles.css"

const accessControlEnhancer = BaseComponent =>
  class accessControl extends Component {
    state = {
      ok: false,
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
      const { queryParams } = this.props
      /* Search for code first (to refresh existen token if needed) */
      const { code } = queryParams
      const { props } = this
      const { replaceParams } = props.queryApi

      if (props.token) {
        this.setState({
          ok: true,
        })
      } else if (code) {
        /* Request to get token */
        refreshTokenByCode(code)
          .then(() => {
            /* Erase redirectUrl */
            localStorage.removeItem(`redirectUrl`)
            /* Omit authentification params in url query */
            replaceParams(omit(queryParams, [`code`, `requestToken`]))

            /* Tell this component that it allowed to render page */
            this.setState({
              ok: true,
            })
          })
          .catch(() => {
            /* Something went wrong, go to login page again */
            redirectToLoginPage()
          })
      } else {
        redirectToLoginPage()
      }
    }

    render() {
      const { state, props } = this
      return state.ok ? (
        <BaseComponent {...props} />
      ) : (
        <div className={styles.Loader}>
          <Spin duration="fast">
            <LoaderIcon size="medium" color="2d75eb" />
          </Spin>
        </div>
      )
    }
  }

export default /* Hack: https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/redux.md */

compose(
  withRouter,
  connect(
    state => ({
      token: selectToken(state),
    }),
    dispatch => ({
      setTokens: (...args) => dispatch(setTokens(...args)),
    }),
  ),
  withQueryParams(),
  accessControlEnhancer,
)
